import { render, staticRenderFns } from "./BatchExpiryChallenge.vue?vue&type=template&id=56af6146&scoped=true&"
import script from "./BatchExpiryChallenge.vue?vue&type=script&lang=ts&"
export * from "./BatchExpiryChallenge.vue?vue&type=script&lang=ts&"
import style0 from "./BatchExpiryChallenge.vue?vue&type=style&index=0&id=56af6146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af6146",
  null
  
)

export default component.exports